export function getSocial(component) {
  const { instagram, facebook, youtube, twitter, address } = component;
  const social = {};

  if (address) {
    social.address = {
      text: "Endereço",
      link: address,
      icon: "mdi:map-marker",
      size: 24,
    };
  }

  if (instagram) {
    social.instagram = {
      text: "Instagram",
      link: instagram,
      icon: "ant-design:instagram-filled",
      size: 25,
    };
  }

  if (facebook) {
    social.facebook = {
      text: "Facebook",
      link: facebook,
      icon: "brandico:facebook-rect",
      size: 19,
    };
  }

  if (youtube) {
    social.youtube = {
      text: "Youtube",
      link: youtube,
      icon: "fab fa-youtube",
      size: 18,
    };
  }

  if (twitter) {
    social.twitter = {
      text: "Twitter",
      link: twitter,
      icon: "fab fa-twitter",
      size: 18,
    };
  }

  return social;
}
